<div class="page-header">
    <div class="page-header-text">
        <h1 class="page-header-title">{{ displayTitle() }}</h1>
        @if (statusData()) {
            <div class="page-subtitle">
                Crestron {{ statusData()?.controllerPromptName }} ({{ statusData()?.devicePlatform }}) &bull; {{ statusData()?.network?.ipAddress }} &bull; {{t()('pageHeader.status')}}:
                <span class="status-{{ connectionStatus() }}">{{ connectionStatus() | titlecase }}</span>
            </div>
        }
    </div>
    @if (apiInitialized()) {
        <div class="dashboard-live-indicator" [class.status-connecting]="connectionStatus() !== 'connected'">
            <span class="live-dot"></span>
            {{ connectionStatus() === 'connected' ? t()('pageHeader.live') : t()('pageHeader.connecting') }}
        </div>
    }
</div>
